import { createContext } from "react";

export const ResizeUndoContext = createContext(null);
